import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import SVGIcon from 'react-svg';
import { fontSizeMapper } from '@appspotr/app';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion';
var FontIconSingle = function (_a) {
    var icon = _a.icon, size = _a.size, color = _a.color;
    var selectedSize = size || '2x';
    if (icon && icon.extId) {
        var fontSize_1 = fontSizeMapper[size] ? "".concat(fontSizeMapper[size], "px") : size;
        return (_jsx(SVGIcon, { afterInjection: function (error) {
                if (error) {
                    console.error(error);
                }
            }, beforeInjection: function (svg) {
                svg.classList.add('svg-class-name');
                svg.setAttribute('style', "height: ".concat(fontSize_1, ";\n             width: ").concat(fontSize_1, ";\n             color: ").concat(color, "; margin-top:-3px"));
            }, src: "".concat(process.env.ICON_BUCKET_URL, "/").concat(icon.extId) }));
    }
    return icon ? (_jsx(FontAwesomeIcon, { color: color || 'unset', size: selectedSize, icon: icon || faQuestion })) : null;
};
FontIconSingle.propTypes = {
    icon: PropTypes.object,
    size: PropTypes.string,
    color: PropTypes.string,
};
export default FontIconSingle;
